import { datadogLogs } from "@datadog/browser-logs";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { hasCookiePermission } from "../layout/cookies/CookieFunctions";

class DatadogLogger {
  constructor() {
    this.isEnabled = this._checkEnabled();
  }

  _checkEnabled() {
    const DDConsent = hasCookiePermission("dataDog");
    const disableAnalytics =
      getEnvironmentVariable("DISABLE_ANALYTICS") === "true";
    const isDev = getEnvironmentVariable("IS_DEV") === "true";

    return DDConsent && !disableAnalytics && !isDev;
  }

  logForceLogout(context = {}) {
    if (!this.isEnabled) return;

    const authContext = this._getAuthContext();
    const sessionDuration = this._calculateSessionDuration(authContext);
    const logoutId = Math.floor(1000 + Math.random() * 9000);

    datadogLogs.logger.info(`Forced user logout - event: force_logout - id: ${logoutId}`, {
      event: "force_logout",
      category: "authentication",
      reason: context.reason || "unknown",
      trigger: context.trigger || "unknown",
      component: context.component,
      sessionDuration,
      error: {
        message: context.error || context.originalError,
        httpStatus: context.httpStatus,
        apiEndpoint: context.apiEndpoint || context.endpoint,
        retryAttempt: context.retryAttempt || false,
        sessionCorrupted: context.sessionCorrupted || false
      },
      user: {
        id: authContext?.identity?.userId,
        email: authContext?.identity?.email,
        isAuthenticated: !!authContext?.identity
      },
      session: {
        id: authContext?.accessTokenDecoded?.jti,
        expired: authContext?.idTokenExpired || authContext?.accessTokenExpired
      },
      environment: getEnvironmentVariable("AMPLIFY_BRANCH")
    });
  }

  _calculateSessionDuration(authContext) {
    try {
      if (!authContext?.accessTokenDecoded?.iat) return null;

      const sessionStartTime = authContext.accessTokenDecoded.iat * 1000;
      const currentTime = Date.now();
      const durationMs = currentTime - sessionStartTime;

      return {
        totalMinutes: Math.round(durationMs / (1000 * 60)),
        totalSeconds: Math.round(durationMs / 1000)
      };
    } catch (err) {
      return null;
    }
  }

  _getAuthContext() {
    try {
      const AUTH_CLIENT_ID = getEnvironmentVariable("AUTH_CLIENT_ID");
      const idTokenString = localStorage?.getItem(
        `AuthIdentityServiceProvider.${AUTH_CLIENT_ID}.idToken`
      );
      const accessTokenString = localStorage?.getItem(
        `AuthIdentityServiceProvider.${AUTH_CLIENT_ID}.accessToken`
      );

      if (!idTokenString || !accessTokenString) {
        return null;
      }

      const { decodeToken, isExpired } = require("react-jwt");

      return {
        identity: decodeToken(idTokenString),
        idTokenExpired: isExpired(idTokenString),
        accessTokenDecoded: decodeToken(accessTokenString),
        accessTokenExpired: isExpired(accessTokenString)
      };
    } catch (err) {
      return null;
    }
  }
}

export const datadogLogger = new DatadogLogger();
